import clsx from 'clsx';
import { Paragraph } from '../typography';

type CommonColorVariant = 'red' | 'violet' | 'aubergine';

type CommonProps = {
  label: string;
};

type ConditionalProps =
  | {
      type?: 'pill';
      colorVariant?: CommonColorVariant | 'orange' | 'redBorder' | 'lightBlue' | 'disabled';
    }
  | {
      type?: 'tag';
      colorVariant?: CommonColorVariant | 'black';
    };

type Props = CommonProps & ConditionalProps;

const getColorStyles = (type: ConditionalProps['type'], colorVariant: ConditionalProps['colorVariant']) => {
  const isRed = colorVariant === 'red';
  const isViolet = colorVariant === 'violet';
  const isAubergine = colorVariant === 'aubergine';
  const isOrange = colorVariant === 'orange';
  const isBlack = colorVariant === 'black';
  const isRedBorder = colorVariant === 'redBorder';
  const isLightBlue = colorVariant === 'lightBlue';
  const isDisabled = colorVariant === 'disabled';

  if (type === 'pill') {
    return clsx({
      'bg-red-0': isRed,
      'bg-red-violet-25': isViolet,
      'bg-aubergine-25': isAubergine,
      'bg-orange-25': isOrange,
      'body-md h-32 w-[50px] bg-[#D3E3E5] px-8 text-black-50': isLightBlue,
      'body-md w-[50px] border-1 border-[#E1E2E3] bg-transparent px-8 text-[#505057]': isDisabled,
      'border-1 border-red-100 bg-transparent': isRedBorder,
    });
  }

  return clsx({
    'border-1 border-red-100': isRed || isRedBorder,
    'border-1 border-aubergine-100': isAubergine,
    'border-1 border-red-violet-100': isViolet,
    'border-1 border-black-100': isBlack,
  });
};

const Label = ({ label, type, colorVariant }: Props) => {
  return (
    <div
      className={`h-fit w-fit px-8 py-4 text-center ${clsx({
        'rounded-full': type === 'pill',
        'rounded-4': type === 'tag',
      })} ${getColorStyles(type, colorVariant)} `}
    >
      <Paragraph
        variant="small"
        classes={clsx({
          'text-red-100': colorVariant === 'red' || colorVariant === 'redBorder',
          'text-red-violet-100': colorVariant === 'violet',
          'text-aubergine-100': colorVariant === 'aubergine',
          'text-orange-100': colorVariant === 'orange',
          'text-black-100': colorVariant === 'black',
          // 'bg-[#D3E3E5] text-[#23383C]': colorVariant === ''
        })}
      >
        {label}
      </Paragraph>
    </div>
  );
};

export default Label;
